import { List, Map } from 'immutable';

export const economicUnitsCodeListSelector = state =>
  state
    .getIn(['app', 'appraisal', 'economicunit', 'econUnitCodeList'])
    .toJS();

export const economicUnitsSearchYearSelector = state =>
  state.getIn(['app', 'appraisal', 'economicunit', 'selectedSearchYear']);

export const economicUnitsSearchSelector = state =>
  state.getIn(['app', 'appraisal', 'economicunit', 'economicUnits']);

export const searchLastPayloadSelector = state =>
  state
    .getIn(['app', 'appraisal', 'economicunit', 'searchLastPayload', 'data'])
    .toJS();

export const searchConfigsSelector = state =>
  state.getIn(['app', 'appraisal', 'economicunit', 'searchConfigs']);

export const economicUnitSelector = state =>
  state.getIn(['app', 'appraisal', 'economicunit', 'economicUnit']);

export const economicUnitPropertiesSelector = state =>
  state.getIn(['app', 'appraisal', 'economicunit', 'economicUnitProperties']);

export const economicUnitPropertyUsesSelector = state =>
  state.getIn(['app', 'appraisal', 'economicunit', 'economicUnitPropertyUses']);

export const economicUnitPropUseRentRollsSelector = state =>
  state.getIn([
    'app',
    'appraisal',
    'economicunit',
    'economicUnitPropUseRentRolls',
  ]);
export const economicUnitRentRollsSelector = state =>
  state.getIn(['app', 'appraisal', 'economicunit', 'economicUnitRentRolls']);

export const economicUnitsSearchParamsSelector = state =>
  state
    .getIn(['app', 'appraisal', 'economicunit', 'searchParams', 'data'])
    .toJS();

export const economicUnitsSearchParamsStateSelector = state =>
  state.getIn(['app', 'appraisal', 'economicunit', 'searchParams']).toJS()
    .state;

export const economicUnitsSearchParamSelector = state =>
  state
    .getIn(['app', 'appraisal', 'economicunit', 'searchParam', 'data'], {})
    .toJS();

export const economicUnitsSearchParamStateSelector = state =>
  state.getIn(['app', 'appraisal', 'economicunit', 'searchParam']).toJS().state;

export const economicUnitsSearchConfigSelector = state =>
  state
    .getIn(['app', 'appraisal', 'economicunit', 'searchConfig', 'data'])
    .toJS();
export const economicUnitsSearchConfigStateSelector = state =>
  state.getIn(['app', 'appraisal', 'economicunit', 'searchConfig']).toJS()
    .state;

export const paginationSelector = state =>
  state
    .getIn(['app', 'appraisal', 'economicunit', 'economicUnits', 'pagination'])
    .toJS();

export const eventSearchValueSelector = state =>
  state.getIn([
    'app',
    'appraisal',
    'economicunit',
    'events',
    'eventSearchValue',
  ]);

export const economicUnitEventsSelector = state =>
  state
    .getIn(['app', 'appraisal', 'economicunit', 'events', 'data'], [])
    .toJS();

export const economicUnitEventFormOptionsSelector = state =>
  state
    .getIn(['app', 'appraisal', 'economicunit', 'eventFormOptions', 'data'], [])
    .toJS();

export const economicUnitIncomeValuationsSelector = state =>
  state
    .getIn(
      ['app', 'appraisal', 'economicunit', 'economicUnitIncomeValuations'],
      [],
    )
    .toJS();

export const validApproachesSelector = state =>
  state
    .getIn(['app', 'appraisal', 'economicunit', 'validApproaches'], [])
    .toJS();

export const incomeDirectCapSelector = state =>
  state
    .getIn(['app', 'appraisal', 'economicunit', 'incomeDirectCap', 'data'], {})
    .toJS();

export const incomeDirectCapActualsSelector = state =>
  state
    .getIn(
      ['app', 'appraisal', 'economicunit', 'incomeDirectCapActuals', 'data'],
      {},
    )
    .toJS();

export const incomeDirectActualsPropertyUsesStateSelector = state =>
  state.getIn([
    'app',
    'appraisal',
    'economicunit',
    'incomeDirectActualsPropertyUses',
    'state',
  ]);

export const incomeDirectActualsPropertyUsesSelector = state =>
  state
    .getIn(
      [
        'app',
        'appraisal',
        'economicunit',
        'incomeDirectActualsPropertyUses',
        'data',
      ],
      {},
    )
    .toJS();
export const incomeDirectActualsExpensesStateSelector = state =>
  state.getIn([
    'app',
    'appraisal',
    'economicunit',
    'incomeDirectActualsExpenses',
    'state',
  ]);
export const incomeDirectActualsExpensesSelector = state =>
  state
    .getIn(
      [
        'app',
        'appraisal',
        'economicunit',
        'incomeDirectActualsExpenses',
        'data',
      ],
      {},
    )
    .toJS();
export const incomeDirectActualsAddlIncomeStateSelector = state =>
  state.getIn([
    'app',
    'appraisal',
    'economicunit',
    'incomeDirectActualsAddlIncome',
    'state',
  ]);
export const incomeDirectActualsAddlIncomeSelector = state =>
  state
    .getIn(
      [
        'app',
        'appraisal',
        'economicunit',
        'incomeDirectActualsAddlIncome',
        'data',
      ],
      {},
    )
    .toJS();
export const incomeDirectActualsAddlIncomeEGIStateSelector = state =>
  state.getIn([
    'app',
    'appraisal',
    'economicunit',
    'incomeDirectActualsAddlIncomeEGI',
    'state',
  ]);
export const incomeDirectActualsAddlIncomeEGISelector = state =>
  state
    .getIn(
      [
        'app',
        'appraisal',
        'economicunit',
        'incomeDirectActualsAddlIncomeEGI',
        'data',
      ],
      {},
    )
    .toJS();
export const getNotes = state =>
  state.getIn(['app', 'appraisal', 'economicunit', 'notes', 'data'], []).toJS();

export const getNotesState = state =>
  state.getIn(['app', 'appraisal', 'economicunit', 'notes', 'state']);

export const getEconomicUnitSelectorFilesState = state =>
  state.getIn(['app', 'appraisal', 'economicunit', 'files', 'state']);

export const codeFileSelector = state =>
  state
    .getIn(
      ['app', 'appraisal', 'economicunit', 'codeFiles', 'data'],
      Map({ data: List() }),
    )
    .toJS();

export const getEconomicUnitPropertyValuations = state =>
  state
    .getIn(
      [
        'app',
        'appraisal',
        'economicunit',
        'economicUnitPropertyValuations',
        'data',
      ],
      Map({ valuations: List(), includedValue: 0 }),
    )
    .toJS();

export const getEconomicUnitReconcile = state =>
  state
    .getIn(
      ['app', 'appraisal', 'economicunit', 'economicUnitReconcile', 'data'],
      Map({}),
    )
    .toJS();

export const getEconomicUnitAllocation = state =>
  state
    .getIn(
      ['app', 'appraisal', 'economicunit', 'economicUnitAllocate', 'data'],
      Map({}),
    )
    .toJS();

export const getEconomicUnitDistribution = state =>
  state
    .getIn(
      ['app', 'appraisal', 'economicunit', 'economicUnitDistribution'],
      Map({ data: List(), state: null }),
    )
    .toJS();

export const isRecalculatingSelector = state =>
  state.getIn(['app', 'appraisal', 'economicunit', 'isRecalculating']);

export const overrideRentSummarySelector = state =>
  state
    .getIn(
      ['app', 'appraisal', 'economicunit', 'overrideRentSummary', 'data'],
      [],
    )
    .toJS();

export const overrideRentSummaryStateSelector = state =>
  state
    .getIn(
      ['app', 'appraisal', 'economicunit', 'overrideRentSummary', 'state']
    );

export const overrideRentRateTypesSelector = state =>
  state
    .getIn(
      ['app', 'appraisal', 'economicunit', 'overrideRentRateTypes'],
      [],
    )
    .toJS();

export const overrideRentsSelector = state =>
  state
    .getIn(
      ['app', 'appraisal', 'economicunit', 'overrideRents'],
      [],
    )
    .toJS();
